import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseReleaseStatus } from '../../enums/warehouse-release-status';
import { WarehouseReleaseStatusPipe } from '../../pipes/warehouse-release-status.pipe';

@Component({
  selector: 'app-warehouse-release-status',
  imports: [CommonModule, WarehouseReleaseStatusPipe],
  templateUrl: './warehouse-release-status.component.html',
  styleUrl: './warehouse-release-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReleaseStatusComponent {
  public readonly status = input.required<WarehouseReleaseStatus>();
}
